import { DayBlockDTO, IDayBlockDTO } from './day-block';
import { ISaveCancelButtonConfig, SaveCancelButtonConfig } from './form/button';

export interface IConfirmDialogConfig {
  id?: number;
  title: string;
  messageList: string[];
  submit: ISaveCancelButtonConfig;
  showOpenField?: boolean;
  openFieldPlaceholder?: string;
  openFieldVal?: string;
  showBlock?: boolean;
  block?: IDayBlockDTO;
  data?: any;
}

export class ConfirmDialogConfig implements IConfirmDialogConfig {
  id?: number = 0;
  title: string = 'Confirm';
  messageList: string[] = ['Do you want to continue?'];
  submit: ISaveCancelButtonConfig = new SaveCancelButtonConfig();
  showOpenField: boolean = false;
  openFieldPlaceholder: string = '';
  openFieldVal: string = '';
  showBlock?: boolean = false;
  block?: IDayBlockDTO = new DayBlockDTO();
  data?: any = null;

  constructor(configOverride?: Partial<IConfirmDialogConfig>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
